import { render, staticRenderFns } from "./accountIndex.vue?vue&type=template&id=5c235a6c&scoped=true&"
import script from "./accountIndex.vue?vue&type=script&lang=js&"
export * from "./accountIndex.vue?vue&type=script&lang=js&"
import style0 from "./accountIndex.vue?vue&type=style&index=0&id=5c235a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c235a6c",
  null
  
)

export default component.exports